/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-07.
 * Exports all text components
 */
import EditableInline from './editableInline';
import EditableInlineV2 from './editableInlineV2';

export { EditableInline, EditableInlineV2 };



// WEBPACK FOOTER //
// ./components/text/index.js